<template>
    <div class="header-container">
        <div class="logo-container fade-scale in" @mousemove="handleMouseMove" @mouseleave="handleMouseLeave">
            <div id="inner-header"
                 @click="navigateToHome"
                 style="text-shadow: rgb(187, 187, 187) 0px 1px 0px, rgb(181, 181, 181) 0px 1px 0px, rgb(172, 172, 172) 0px 2px 0px, rgb(160, 160, 160) 0px 3px 0px, rgb(145, 145, 145) 0px 4px 0px, rgb(127, 127, 127) 0px 4px 0px, rgba(0, 0, 0, 0.2) 0px 5px 1px, rgba(0, 0, 0, 0.3) 0px 10px 6px; transform: translateZ(99px) rotateX(7.5deg) rotateY(0deg);">
                <div class="logo-subtitle">Institute of Zoology</div>
                <div class="logo-subtitle">Chinese Academy of Sciences</div>
                <div class="logo-title">Guo Lab</div>
            </div>
        </div>
        <div class="header-middle">
            <el-menu
                :default-active="$route.path"
                mode="horizontal"
                text-color="#000000"
                active-text-color="#64AFD8"
                router
            >
                <el-menu-item v-for="(item, index) in menuItems" :key="index" :index="item.path">{{ item.name }}</el-menu-item>
            </el-menu>
        </div>
        <div class="header-right">
            <el-radio-group v-model="language" size="mini" fill="#64AFD8" @change="handleLanguageChange">
                <el-radio-button label="en">EN</el-radio-button>
                <el-radio-button label="zh">CN</el-radio-button>
            </el-radio-group>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderCom',
    data() {
        return {
            activeIndex: '/home',
            menuItems: [
                {path: '/home', name: 'Research'},
                {path: '/people', name: 'People'},
                {path: '/publications', name: 'Publications'},
                {path: '/resources', name: 'Resources'},
                {path: '/labnews', name: 'LabNews'},
                {path: '/joinUs', name: 'Join Us'},
            ],
            slideMenu: 'slide-menu'
        };
    },
    computed: {
        language: {
            get() {
                return this.$store.state.language;
            },
            set(value) {
                this.$store.dispatch('setLanguage', value);
            },
        },
    },
    methods: {
        navigateToHome(){
            this.$router.push('/home');
        },
        handleLanguageChange(value) {
            this.$i18n.locale = value;
        },
        handleMouseMove(event) {
            if (!this.innerHeaderElement) {
                this.innerHeaderElement = document.getElementById("inner-header");
            }

            // 使用 requestAnimationFrame 进行节流
            if (!this.mouseMoveRAF) {
                this.mouseMoveRAF = requestAnimationFrame(() => {
                    this.updateMouseEffect(event);
                    this.mouseMoveRAF = null;
                });
            }
        },
        updateMouseEffect(event) {
            // 获取目标元素
            const element = this.innerHeaderElement;

            // 获取目标元素的位置信息
            const {left, top, width, height} = element.getBoundingClientRect();

            // 从事件中提取鼠标的客户端位置（相对于视口的坐标）
            const {clientX, clientY} = event;

            // 计算鼠标相对于目标元素的水平和垂直偏移量
            const e = Math.round((7 / (width / 2)) * (width / 2 - (clientX - left)));
            const a = Math.round((7 / (height / 2)) * (height / 2 - (clientY - top)));

            // 输出计算结果（e 和 a）到控制台，帮助调试
            // console.log(e,a)

            // 初始化 textShadow 字符串，用于存储生成的文本阴影效果
            let textShadow = "";

            // 设置颜色强度的初始值
            let colorIntensity = 190;

            // 循环7次，逐渐增加阴影的偏移量，并逐步减少颜色强度
            for (let r = 0; r < 7; r++) {
                // 计算当前阴影的水平和垂直偏移量
                const offsetX = Math.round((e / 7) * r);
                const offsetY = Math.round((a / 7) * r);

                // 如果偏移量不为零，计算颜色强度并生成阴影效果
                if (offsetX || offsetY) {
                    // 减少颜色强度（随着偏移量增加颜色会变暗）
                    colorIntensity -= 3 * r;
                    // 生成文本阴影字符串
                    textShadow += `${offsetX}px ${offsetY}px 0 rgb(${colorIntensity}, ${colorIntensity}, ${colorIntensity}), `;
                }
            }

            // 添加最终的两个阴影效果，增加深度和模糊
            textShadow += `${e}px ${a}px 1px rgba(0,0,0,0.2), ${2 * e}px ${2 * a}px 6px rgba(0,0,0,0.3)`;

            // 将生成的文本阴影效果应用到目标元素的样式中
            element.style.textShadow = textShadow;

            // 计算并设置元素的 3D 变换效果（旋转）
            const transform = `translateZ(99px) rotateX(${1.5 * a}deg) rotateY(${1.5 * -e}deg)`;

            // 应用 3D 变换效果到目标元素，支持不同浏览器前缀
            element.style.transform = transform;
            element.style.webkitTransform = transform;
            element.style.MozTransform = transform;
        },

        handleMouseLeave() {
            if (!this.innerHeaderElement) {
                this.innerHeaderElement = document.getElementById("inner-header");
            }
            const d = this.innerHeaderElement;
            d.style.textShadow = "rgb(187, 187, 187) 0px 1px 0px, rgb(181, 181, 181) 0px 1px 0px, rgb(172, 172, 172) 0px 2px 0px, rgb(160, 160, 160) 0px 3px 0px, rgb(145, 145, 145) 0px 4px 0px, rgb(127, 127, 127) 0px 4px 0px, rgba(0, 0, 0, 0.2) 0px 5px 1px, rgba(0, 0, 0, 0.3) 0px 10px 6px";
            d.style.transform = "translateZ(99px) rotateX(0deg) rotateY(0deg)";
            d.style.webkitTransform = "translateZ(99px) rotateX(0deg) rotateY(0deg)";
            d.style.MozTransform = "translateZ(99px) rotateX(0deg) rotateY(0deg)";
        },
    },
    mounted() {
        this.innerHeaderElement = null; // 缓存 DOM 引用
        this.mouseMoveRAF = null;       // 用于节流的 requestAnimationFrame 标志
    },
}
</script>
<style scoped lang="scss">
@use "src/assets/css/variables.scss" as *;

.header-container {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 84%;
    padding: 20px 8%;
    background-color: transparent;
    height: 80px;
    z-index: 999;
    transition: all 0.5s;

    .fade-scale {
        opacity: .8;
        transition: .6s ease-in-out;
        transform: scale(.55);
    }

    .fade-scale.in {
        opacity: 1;
        transform: none;
    }

    .logo-container {
        position: relative;
        font-family: 'fontlogo', sans-serif;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 80px;
        cursor: pointer;
    }

    #inner-header {
        width: 400px;
        color: #f3f3f3;
        text-align: center;
        transition: all 0.3s ease; /* 添加过渡效果 */
        text-shadow: #bbb 0 1px 0, #b5b5b5 0 2px 0, #acacac 0 3px 0, #a0a0a0 -1px 3px 0, #919191 -1px 4px 0, #7f7f7f -1px 5px 0, rgba(0, 0, 0, .2) -1px 6px 1px, rgba(0, 0, 0, .3) -2px 12px 6px;
        transform: translateZ(99px) rotateX(0deg) rotateY(0deg);
    }

    .logo-subtitle {
        letter-spacing: 1px;
        font-size: 20px;
        color: #222222BF;
        font-weight: 400;
    }

    .logo-title {
        font-size: 40px;
        font-weight: 400;
        color: #565656;
    }

    .header-middle {
        .el-menu {
            background-color: transparent; /* 去掉背景颜色 */
        }

        .el-menu-item {
            font-size: 22px;
            font-weight: 700;
            background-color: transparent !important; /* 禁用默认背景色 */
            overflow: hidden;
            position: relative;
        }

        .el-menu-item.is-active {
            background-color: transparent !important; /* 禁用选中项的背景色 */
            color: #64AFD8 !important; /* 自定义选中项文字颜色 */
        }

        .el-menu-item:hover {
            color: #64AFD8 !important; /* 鼠标悬浮状态文字颜色 */
            //font-size: 24px;
            background-color: transparent !important; /* 禁用悬停时的背景色 */
        }

    }

    .header-right {
        ::v-deep .el-radio-button--mini .el-radio-button__inner {
            font-size: 7px;
            width: 10px;
            padding: 5px;
            box-sizing: content-box;
        }
    }
}
/* 新增的媒体查询样式 */
@media (max-width: 1500px) {
    .header-container {
        flex-direction: row; /* 调整布局为垂直方向 */
        //align-items: stretch;  /* 让子元素填满宽度 */
    }

    .logo-container {
        display: none !important; /* 隐藏 logo-container */
    }

    .header-middle {
        text-align: center; /* 居中菜单 */
    }

    .header-right {
        text-align: center; /* 居中语言切换 */
    }
}
</style>
